import { z } from 'zod';

export const TimeSlotSchema = z
    .object({
        date: z.string(),
        time: z.string(),
    });

export type TimeSlot = z.TypeOf<typeof TimeSlotSchema>;